[
    {
        "ID": 101,
        "NAME": "NORTH AMERICA",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "6.9 GB",
        "VERSION": "v1175",
        "IMAGE_NAME": "sea.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 102,
        "NAME": "NORTH AMERICA",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "9.0 GB",
        "VERSION": "v1176",
        "IMAGE_NAME": "sea.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 103,
        "NAME": "NORTH AMERICA",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "10.1 GB",
        "VERSION": "v1176",
        "IMAGE_NAME": "sea.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 104,
        "NAME": "NORTH AMERICA",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "6.9 GB",
        "VERSION": "v1175",
        "IMAGE_NAME": "sea.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 105,
        "NAME": "NORTH AMERICA",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "16.9 GB",
        "VERSION": "v2026.03",
        "IMAGE_NAME": "sea.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 107,
        "NAME": "SOUTH AMERICA",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "27.1 GB",
        "VERSION": "v2026.06",
        "IMAGE_NAME": "southAmerica.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 108,
        "NAME": "EUROPE",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "28.4 GB",
        "VERSION": "v2026.06",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 109,
        "NAME": "INDIA",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "27.1 GB",
        "VERSION": "v2026.06",
        "IMAGE_NAME": "India.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 110,
        "NAME": "ASIA PACIFIC",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "27.1 GB",
        "VERSION": "v2026.06",
        "IMAGE_NAME": "aisa_pacific.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 111,
        "NAME": "NORTH AMERICA",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "17.9 GB",
        "VERSION": "v2026.06",
        "IMAGE_NAME": "sea.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 112,
        "NAME": "OCEANIA",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "27.1 GB",
        "VERSION": "v2026.06",
        "IMAGE_NAME": "oceania.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 113,
        "NAME": "EUROPE",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "17.7 GB",
        "VERSION": "v2025.12",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 114,
        "NAME": "ISRAEL",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "12.9 GB",
        "VERSION": "v2023.12",
        "IMAGE_NAME": "Israel.jpg",
        "UPLOAD_DATE": "2024-03-19 00:00:00"
    },
    {
        "ID": 115,
        "NAME": "MIDDLE EAST ARABIC",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "1.2 GB",
        "VERSION": "v2023.12",
        "IMAGE_NAME": "Middle_East_Arabic.jpg",
        "UPLOAD_DATE": "2024-03-19 00:00:00"
    },
    {
        "ID": 116,
        "NAME": "AFRICA",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "12.9 GB",
        "VERSION": "v2023.12",
        "IMAGE_NAME": "Africa.jpg",
        "UPLOAD_DATE": "2024-03-19 00:00:00"
    },
    {
        "ID": 117,
        "NAME": "SOUTH EAST ASIA",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "12.9 GB",
        "VERSION": "v2023.12",
        "IMAGE_NAME": "south-east-asia.jpg",
        "UPLOAD_DATE": "2024-03-19 00:00:00"
    },
    {
        "ID": 118,
        "NAME": "LATIN AMERICA",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "12.9 GB",
        "VERSION": "v2023.12",
        "IMAGE_NAME": "latin-america.jpg",
        "UPLOAD_DATE": "2024-03-19 00:00:00"
    },
    {
        "ID": 119,
        "NAME": "OCEANIA",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "1.8 GB",
        "VERSION": "v2026.03",
        "IMAGE_NAME": "oceania.jpg",
        "UPLOAD_DATE": "2026-03-18 00:00:00"
    },
	{
        "ID": 120,
        "NAME": "SOUTH AMERICA",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "6.5 GB",
        "VERSION": "v2026.03",
        "IMAGE_NAME": "southAmerica.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 121,
        "NAME": "SOUTH AMERICA",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "7.5 GB",
        "VERSION": "v2026.06",
        "IMAGE_NAME": "southAmerica.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 122,
        "NAME": "NORTH AMERICA",
        "DESCRIPTION": "fca.index.softwareMessage",
        "SIZE": "17.9 GB",
        "VERSION": "v2026.06",
        "IMAGE_NAME": "sea.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 200,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "7.7 GB",
        "VERSION": "v1140.12581",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 201,
        "NAME": "Tivoli Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "129 MB",
        "VERSION": "R6.3",
        "IMAGE_NAME": "Tivoli.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 202,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "7.7 GB",
        "VERSION": "v1140.12581",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 203,
        "NAME": "Tivoli Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "129 MB",
        "VERSION": "R6.3",
        "IMAGE_NAME": "Tivoli.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 204,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "7.7 GB",
        "VERSION": "v1140.12581",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 205,
        "NAME": "Korando Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "130 MB",
        "VERSION": "R6.3",
        "IMAGE_NAME": "Korando.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 206,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "8.0 GB",
        "VERSION": "v1170.13183",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 207,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "1.1 GB",
        "VERSION": "v1170.13204",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 208,
        "NAME": "REXTON Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "390 MB",
        "VERSION": "R6.0.3",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 209,
        "NAME": "MUSSO/REXTON SPORTS Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "390 MB",
        "VERSION": "R6.0.3",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 210,
        "NAME": "Tivoli Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "389 MB",
        "VERSION": "R6.0.3",
        "IMAGE_NAME": "Tivoli.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 211,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "8.0 GB",
        "VERSION": "v1170.13183",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 212,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "1.1 GB",
        "VERSION": "v1170.13204",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 213,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "8.0 GB",
        "VERSION": "v1170.13183",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 214,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "1.1 GB",
        "VERSION": "v1170.13204",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 216,
        "NAME": "Mahindra Navigation system software (ONLY INDIA)",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "390 MB",
        "VERSION": "R6.0.3",
        "IMAGE_NAME": "Mahindra.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 217,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "8.0 GB",
        "VERSION": "v1170.13183",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 218,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "8.0 GB",
        "VERSION": "v1170.13183",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 219,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "1.1 GB",
        "VERSION": "v1170.13204",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 221,
        "NAME": "Korando Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "458 MB",
        "VERSION": "R5.0.95",
        "IMAGE_NAME": "Korando.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 222,
        "NAME": "Tivoli Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "458 MB",
        "VERSION": "R5.0.95",
        "IMAGE_NAME": "Tivoli.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 223,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "22.5 GB",
        "VERSION": "v10.0.0",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 224,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "4.7 GB",
        "VERSION": "v10.0.0",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 231,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "4.7 GB",
        "VERSION": "v7.0.0",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 232,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "22.5 GB",
        "VERSION": "v7.0.0",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 233,
        "NAME": "REXTON Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "1.5  GB",
        "VERSION": "V578",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": "V01.01.78"
    },
    {
        "ID": 234,
        "NAME": "Korando Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "747 MB",
        "VERSION": "R5.0.85",
        "IMAGE_NAME": "Korando.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 235,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "22.5 GB",
        "VERSION": "v10.0.0",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 236,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "4.7 GB",
        "VERSION": "v10.0.0",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 237,
        "NAME": "MUSSO/REXTON SPORTS Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "752 MB",
        "VERSION": "R5.0.53",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 238,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "4.7 GB",
        "VERSION": "v10.0.0",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 239,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "22.5 GB",
        "VERSION": "v10.0.0",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 240,
        "NAME": "TORRES Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "747 MB",
        "VERSION": "R5.1.14",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 241,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "8.0 GB",
        "VERSION": "v1170.13183",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 242,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "1.1 GB",
        "VERSION": "v1170.13204",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 243,
        "NAME": "Tivoli Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "458 MB",
        "VERSION": "R5.0.95",
        "IMAGE_NAME": "Tivoli.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 244,
        "NAME": "REXTON Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "1.5 GB",
        "VERSION": "V549",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 245,
        "NAME": "MUSSO/REXTON SPORTS Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "1.5 GB",
        "VERSION": "V549",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 246,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "22.5 GB",
        "VERSION": "v10.0.0",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 247,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "4.7 GB",
        "VERSION": "v10.0.0",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 248,
        "NAME": "REXTON Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "747 MB",
        "VERSION": "R5.1.43",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 249,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "4.7 GB",
        "VERSION": "v7.0.0",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 250,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "4.7 GB",
        "VERSION": "v7.0.0",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 251,
        "NAME": "REXTON Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "1.5 GB",
        "VERSION": "R5.00.24",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 253,
        "NAME": "Korando Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "812 MB",
        "VERSION": "R5.0.23",
        "IMAGE_NAME": "Korando.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 255,
        "NAME": "TORRES Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "2.4 GB",
        "VERSION": "R5.01.21",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 257,
        "NAME": "Actyon Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "2.2 GB",
        "VERSION": "R5.01.22",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 259,
        "NAME": "TORRES EV Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "2.4 GB",
        "VERSION": "R5.01.42",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 261,
        "NAME": "Tivoli Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "812 MB",
        "VERSION": "R5.0.23",
        "IMAGE_NAME": "Tivoli.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 263,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "22.5 GB",
        "VERSION": "v7.0.0",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 264,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "4.7 GB",
        "VERSION": "v7.0.0",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 265,
        "NAME": "TORRES Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "2.4 GB",
        "VERSION": "R5.01.19",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
	{
        "ID": 266,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "22.5 GB",
        "VERSION": "v7.0.0",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 267,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "4.7 GB",
        "VERSION": "v7.0.0",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 268,
        "NAME": "TORRES Hybrid Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "2.2 GB",
        "VERSION": "R5.01.11",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
	{
        "ID": 269,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "22.5 GB",
        "VERSION": "v7.0.0",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 270,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "4.7 GB",
        "VERSION": "v7.0.0",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 271,
        "NAME": "Actyon Hybrid Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "2.2 GB",
        "VERSION": "R5.01.06",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
	{
        "ID": 272,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "22.5 GB",
        "VERSION": "v7.0.0",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 273,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "4.7 GB",
        "VERSION": "v7.0.0",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 274,
        "NAME": "MUSSO EV Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "2.2 GB",
        "VERSION": "R5.01.11",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
	{
        "ID": 275,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "22.5 GB",
        "VERSION": "v7.0.0",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 276,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "4.7 GB",
        "VERSION": "v7.0.0",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 277,
        "NAME": "TORRES EV Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "2.2 GB",
        "VERSION": "R5.01.09",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
	{
        "ID": 278,
        "NAME": "Europe map + Safety cameras",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "22.5 GB",
        "VERSION": "v7.0.0",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 279,
        "NAME": "Russia Map",
        "DESCRIPTION": "ssangyong.index.MapMessage",
        "SIZE": "4.7 GB",
        "VERSION": "v7.0.0",
        "IMAGE_NAME": "Russia.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
    {
        "ID": 280,
        "NAME": "TORRES Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "2.1 GB",
        "VERSION": "R5.01.07",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
	{
        "ID": 281,
        "NAME": "MUSSO/REXTON SPORTS Navigation system software",
        "DESCRIPTION": "ssangyong.index.SoftwarePkgMessage",
        "SIZE": "2.8 GB",
        "VERSION": "R5.01.07",
        "IMAGE_NAME": "REXTON.jpg",
        "UPLOAD_DATE": "",
        "MCU_VERSION": ""
    },
	
    {
        "ID": 300,
        "NAME": "Europe Truck",
        "DESCRIPTION": "iveco.index.MapMessage",
        "SIZE": "8.1 GB",
        "VERSION": "v1170.1",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "2026-02-19 00:00:00",
        "RELEASE_VERSION": "2026.03"
    },
    {
        "ID": 301,
        "NAME": "Europe Russia Truck",
        "DESCRIPTION": "iveco.index.MapMessage",
        "SIZE": "8.1 GB",
        "VERSION": "v1170.1",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": "2026-05-07 00:00:00",
        "RELEASE_VERSION": "2026.03"
    },
    {
        "ID": 302,
        "NAME": "Africa",
        "DESCRIPTION": "iveco.index.MapMessage",
        "SIZE": "1.1 GB",
        "VERSION": "v1170.1",
        "IMAGE_NAME": "Africa.jpg",
        "UPLOAD_DATE": "2026-05-07 00:00:00",
        "RELEASE_VERSION": "2026.03"
    },
    {
        "ID": 303,
        "NAME": "Israel",
        "DESCRIPTION": "iveco.index.MapMessage",
        "SIZE": "47.7 MB",
        "VERSION": "v1170.2",
        "IMAGE_NAME": "Israel.jpg",
        "UPLOAD_DATE": "2026-05-07 00:00:00",
        "RELEASE_VERSION": "2026.03"
    },
    {
        "ID": 304,
        "NAME": "Middle East Arabic",
        "DESCRIPTION": "iveco.index.MapMessage",
        "SIZE": "427.0 MB",
        "VERSION": "v1170.1",
        "IMAGE_NAME": "Middle_East_Arabic.jpg",
        "UPLOAD_DATE": "2026-05-07 00:00:00",
        "RELEASE_VERSION": "2026.03"
    },
    {
        "ID": 305,
        "NAME": "Oceania Truck",
        "DESCRIPTION": "iveco.index.MapMessage",
        "SIZE": "580.0 MB",
        "VERSION": "v1170.2",
        "IMAGE_NAME": "Oceania_truck.jpg",
        "UPLOAD_DATE": "2026-05-07 00:00:00",
        "RELEASE_VERSION": "2026.03"
    },
    {
        "ID": 306,
        "NAME": "EMEA & APAC",
        "DESCRIPTION": "iveco.index.MapMessage",
        "SIZE": "33.7 GB",
        "VERSION": "v8.0.0",
        "IMAGE_NAME": "EMEA-APAC.jpg",
        "UPLOAD_DATE": "2026-06-26 00:00:00",
        "RELEASE_VERSION": "2026.06"
    },
    {
        "ID": 307,
        "NAME": "Americas",
        "DESCRIPTION": "iveco.index.MapMessage",
        "SIZE": "23.5 GB",
        "VERSION": "v8.0.0",
        "IMAGE_NAME": "americas.jpg",
        "UPLOAD_DATE": "2026-06-26 00:00:00",
        "RELEASE_VERSION": "2026.06"
    },
    {
        "ID": 309,
        "NAME": "South Korea",
        "DESCRIPTION": "iveco.index.MapMessage",
        "SIZE": "2.3 GB",
        "VERSION": "v8.0.0",
        "IMAGE_NAME": "South-Korea.jpg",
        "UPLOAD_DATE": "2026-06-26 00:00:00",
        "RELEASE_VERSION": "2026.06"
    },
    {
        "ID": 400,
        "NAME": "index.South_East_Asia",
        "DESCRIPTION": "melco.index.mapMessage",
        "SIZE": "1.9 GB",
        "VERSION": "3465",
        "IMAGE_NAME": "sea.jpg",
        "UPLOAD_DATE": "2026-06-15 00:00:00"
    },
    {
        "ID": 401,
        "NAME": "index.Africa1",
        "DESCRIPTION": "melco.index.mapMessage",
        "SIZE": "1.2 GB",
        "VERSION": "3455",
        "IMAGE_NAME": "africa.jpg",
        "UPLOAD_DATE": "2025-12-03 00:00:00"
    },
    {
        "ID": 402,
        "NAME": "index.Latin_America_except_Chile",
        "DESCRIPTION": "melco.index.mapMessage",
        "SIZE": "3.1 GB",
        "VERSION": "3460",
        "IMAGE_NAME": "latam.jpg",
        "UPLOAD_DATE": "2026-03-12 00:00:00"
    },
    {
        "ID": 403,
        "NAME": "index.Latin_America_only_for_Chile",
        "DESCRIPTION": "melco.index.mapMessage",
        "SIZE": "2.8 GB",
        "VERSION": "3380",
        "IMAGE_NAME": "latam_chile.jpg",
        "UPLOAD_DATE": "2022-03-01 00:00:00"
    },
    {
        "ID": 404,
        "NAME": "index.Russia1",
        "DESCRIPTION": "melco.index.mapMessage",
        "SIZE": "1.2 GB",
        "VERSION": "3450",
        "IMAGE_NAME": "russia.jpg",
        "UPLOAD_DATE": "2025-10-07 00:00:00"
    },
    {
        "ID": 405,
        "NAME": "index.Europe_except_Russia",
        "DESCRIPTION": "melco.index.mapMessage",
        "SIZE": "8.0 GB",
        "VERSION": "3465",
        "IMAGE_NAME": "europe.jpg",
        "UPLOAD_DATE": "2026-06-15 00:00:00"
    },
    {
        "ID": 406,
        "NAME": "index.Israel",
        "DESCRIPTION": "melco.index.mapMessage",
        "SIZE": "68.4 MB",
        "VERSION": "3345",
        "IMAGE_NAME": "israel.jpg",
        "UPLOAD_DATE": "2021-01-01 00:00:00"
    },
    {
        "ID": 407,
        "NAME": "index.Middle_East_Asia_except_Israel",
        "DESCRIPTION": "melco.index.mapMessage",
        "SIZE": "473 MB",
        "VERSION": "3455",
        "IMAGE_NAME": "mea.jpg",
        "UPLOAD_DATE": "2025-12-03 00:00:00"
    },
    {
        "ID": 408,
        "NAME": "index.Oceania",
        "DESCRIPTION": "melco.index.mapMessage",
        "SIZE": "640 MB",
        "VERSION": "3450",
        "IMAGE_NAME": "oceania.jpg",
        "UPLOAD_DATE": "2025-10-07 00:00:00"
    },
    {
        "ID": 409,
        "NAME": "index.North_America",
        "DESCRIPTION": "melco.index.mapMessage",
        "SIZE": "6.2 GB",
        "VERSION": "3460",
        "IMAGE_NAME": "na.jpg",
        "UPLOAD_DATE": "2026-03-12 00:00:00"
    },
    {
        "ID": 501,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 502,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 503,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 504,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 505,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 506,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 508,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 509,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 510,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 511,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 512,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 513,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 514,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 515,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 516,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
	{
        "ID": 517,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
	{
        "ID": 518,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
	{
        "ID": 519,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
	{
        "ID": 520,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
	{
        "ID": 521,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
	{
        "ID": 522,
        "NAME": "Europe",
        "DESCRIPTION": "mitsubhishi.index.MapMessage",
        "SIZE": "7.9 GB",
        "VERSION": "v1165.13125",
        "IMAGE_NAME": "Europe.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 600,
        "NAME": "Navi 80 Intellilink Navigation system software",
        "DESCRIPTION": "opel.index.SoftwareMessage",
        "SIZE": "457 MB",
        "VERSION": "11.344",
        "IMAGE_NAME": "movano.jpg",
        "UPLOAD_DATE": ""
    },
    {
        "ID": 601,
        "NAME": "Navi 80 Intellilink Navigation system software",
        "DESCRIPTION": "opel.index.SoftwareMessage",
        "SIZE": "457 MB",
        "VERSION": "6.1",
        "IMAGE_NAME": "vivaro.jpg",
        "UPLOAD_DATE": ""
    }
]